var lookSection = {
  scrollPosition: window.scrollY
};

// shopTheLook
var swiper = new Swiper(".shopTheLookSlider", {
  slidesPerView: 1,
  loop: true,
  navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
  }
});

$('.js-look-list-triger').on('click', function () {
  const tabId = $(this).attr('data-product-tab-id');
  $(this).closest('.look-list-item').find('.look-products-list-item').removeClass('active');
  $(this).closest('.look-list-item').find(`.look-products-list-item[data-product-tab="${tabId}"]`).addClass('active');
  $(this).closest('.look-list-item').find('.js-look-list-triger').removeClass('active');
  $(this).closest('.look-list-item').find(`.js-look-list-triger[data-product-tab-id="${tabId}"]`).addClass('active');
  if (window.matchMedia("(max-width: 767px)").matches) {
      const blockIndex = $(this).attr('data-block-index');
      $(this).closest('.shop-the-look').find('.loock-list-product-popup').find('.look-products-list-item').removeClass('active');
      $(this).closest('.shop-the-look').find($(`.look-products-list-${blockIndex}`)).find(`.look-products-list-item[data-product-tab="${tabId}"]`).addClass('active');
      lookSection = {
          scrollPosition: window.scrollY
      };
  }
});

$('.js-close-look-tab').on('click', function () {
  $(this).closest('.product-item').removeClass('active');
});

$(window).scroll(function () {
  if (window.scrollY - lookSection.scrollPosition > 150 || window.scrollY - lookSection.scrollPosition < -150) {
      $('.loock-list-product-popup').find('.product-item').removeClass('active');
  }
});